import { createFileRoute } from "@tanstack/react-router";
import { FormBuilderPanel } from "@/features/form-editor/components/form-builder/form-builder-panel";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/assetTypes/$assetTypeId/full/form/",
)({
	component: AdminAssetTypeFullFormBuilderRoute,
});

function AdminAssetTypeFullFormBuilderRoute() {
	return (
		<div className="flex min-h-[min(70vh,720px)] min-h-0 flex-1 flex-col px-4">
			<FormBuilderPanel />
		</div>
	);
}
